// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host-context(.ios) .user-details-section .user-image-wrapper {
  max-width: 30%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/horizontal-list-sites/styles/user-profile.ios.scss"],"names":[],"mappings":"AAEI;EACE,cAAA;AADN","sourcesContent":[":host-context(.ios) {\r\n  .user-details-section {\r\n    .user-image-wrapper {\r\n      max-width: 30%;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
